import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import CLocalizedTextStringStatic from '../../components/CLocalizedTextStringStatic';
import { PageRoutes } from '../../enums/enums';
import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../store/appSlice';

export default function PContactOutlet() {
  const dispatch = useAppDispatch();
  const contactTitle = CLocalizedTextStringStatic('contact.title');

  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([PageRoutes.CONTACT_OUTLET, contactTitle]));

    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch, contactTitle]);
  return <Outlet />;
}
